module.exports = __webpack_public_path__ + "img/Monte_Kope_25.9af101d7.jpg";